function load(component) {
  // '@' is aliased to src/components
  return () => import('../components/' + component + '.vue')
}

export default [
  {
    path: '/test', name: 'Test', component: load('Test')
  },
  {
    path: '/', component: () => import('layouts/default.vue'), children: [
      {path: '/info', name: 'Info', component: load('Info')},
      {path: '/help', name: 'Help', component: load('Help')},
      {path: '', component: load('Detail')},
      {path: ':id', name: 'Detail', component: load('Detail')},
      {path: '/query/:id', name: 'Query', component: load('Query')},
      {path: '/qapp/:id', name: 'QueryApp', component: load('QueryApp')},
      {path: '/formular/:id/:contentid', name: 'Formular', component: load('Formular')},
      {path: '/we/:id', name: 'Webentity', component: load('Webentity'), props: true},
      {path: '/document/:id/:contentid', name: 'Document', component: load('DocumentView')},
      {path: '/parameter/:id', name: 'Parameter', component: load('Parameter')},
      {path: '/framelink/:id', name: 'Framelink', component: load('Framelink')},
      {path: '/singleRecordView/:id', name: 'SingleRecordView', component: load('SingleRecordView')},
      {path: '/releaseNotes', name: 'ReleaseNotes', component: load('ReleaseNotes')},
      {path: '/gmap', name: 'Gmap', component: load('charts/Gmap')},
      {path: '/chart', name: 'Chart', component: load('charts/Chart')},
      {path: '/gantt', name: 'Gantt', component: load('charts/Gantt')},
      {
        path: '/plugin/:id',
        name: 'Plugin',
        component: load('Plugin'),
        props: route => ({
          ...route.params,
          ...history.state
        })
      }
    ]
  },
  {
    path: '/versionError',
    name: 'VersionError',
    component: () => import('pages/VersionError.vue')
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/404.vue')  // Not found
  }
]

